import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'

export const useResetOnSort = () => {
  let prevSortModel = []

  const getRowsPreHandler = (params) => {
    if (params.api.paginationGetCurrentPage() > 0 && !isEqual(prevSortModel, params.request.sortModel)) {
      // Clear any cached data and reset the page to 0.
      params.api.refreshServerSide({ purge: true })
      params.api.paginationGoToPage(0)

      // It's _critical_ that the success callback is called
      // here to keep AG Grid's internal state consistent.
      params.success()

      return true
    }

    prevSortModel = cloneDeep(params.request.sortModel)

    return false
  }

  return {
    resetOnSort: {
      getRowsPreHandler
    }
  }
}
